import { ApiBase, TOKEN_KEY } from "../utils/Network";
import {
    migrateKurdishTalentHttpUser,
    KT_HTTP_USER_KEY,
} from "../utils/authStorageKeys";

migrateKurdishTalentHttpUser();

export class HttpService {


    headers = new Headers();
    
    static getToken = () => {
        return localStorage.getItem(TOKEN_KEY) || null;
    };

    static setToken = (token) => {
        localStorage.setItem(TOKEN_KEY,token);
    };

    static setUser = (user) => {
        migrateKurdishTalentHttpUser();
        localStorage.setItem(KT_HTTP_USER_KEY,JSON.stringify(user));
    };

    static getUser = () => {
        migrateKurdishTalentHttpUser();
        const raw = localStorage.getItem(KT_HTTP_USER_KEY);
        return raw ? JSON.parse(raw) : null;
    };

    static signOut = () => {
        localStorage.removeItem(KT_HTTP_USER_KEY);
        localStorage.removeItem(TOKEN_KEY);
    };

    getUserToken = () => {
        return localStorage.getItem(TOKEN_KEY) || null;
        
    };

    setHeaders() {
       this.headers.append("Content-Type", "application/json");
       this.headers.append("Accept", "application/json");    
        const auth = this.getUserToken();
        if (auth) this.headers.append("Authorization", "Bearer " + auth);

    }

    

    async get(url,body)  {
        // this.setHeaders();
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");   
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   


        const response = await fetch(`${ApiBase}${url}`, {
        headers: new Headers(headers),
        method: 'GET',
        });

        const data = await response.json();

        if(response.status === 401)
        {
            window.localStorage.removeItem(KT_HTTP_USER_KEY);
            HttpService.setToken("")
            window.location.reload();
        }

        return data;
    }

    async post(url,body,hasFile)  {
        console.log("POST request "+ url +" " + JSON.stringify(body));
        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   
        
        const response = await fetch(`${ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'POST',
            body: hasFile ? body : JSON.stringify(body),
        });



        const data = await response.json();

        console.log(data)

        return data;
    }

    async put(url,body,hasFile=false)  {

        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   
        
        const response = await fetch(`${ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'PUT',
            body: hasFile ? body : JSON.stringify(body),
        });

        const data = await response.json();


        return data;
    }

    async patch(url,body,hasFile)  {
        
        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   
        
        const response = await fetch(`${ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'PATCH',
            body: hasFile ? body : JSON.stringify(body),
        });

        const data = await response.json();

        return data;
    }

    async delete(url) {
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   

        const response = await fetch(`${ApiBase}${url}`, {
        headers: new Headers(headers),
        method: 'DELETE',
        });

        return ;
    }

    async updateActive(url,is_active) {
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   

        var body = {
            "is_active" : is_active
        }

        const response = await fetch(`${ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'PATCH',
            body: JSON.stringify(body),
        });

        const data = await response.json();

        return data;
    }

    

    
}

